import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';
import facebook from '../files/facebook.png';
import instagram from '../files/instagram.jpg';
import twitter from '../files/twitter.png';
import linkedIn from '../files/linkedIn.png';
import call from '../files/call.png';
import email from '../files/email.png';
import address from '../files/address.png';
import github from '../files/github.jpg'
import whatsapp from '../files/whatsapp.png'


export const ContactUs = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_2d9dlrq', 'template_ip7hb6u', form.current, 'h6NBL8r3sutZUxfwK')
            .then((result) => {
                toast.success('message sent successfully !')
                e.target.reset();
            }, (error) => {
                toast.error('failed to send message !')
            });
    };

    return (
        <div id='contact' className='bg-[#242526]   lg:flex lg:h-[500px]'>
            <div className='lg:w-5/12  justify-center grid content-center mb-8'>
                <h2 data-aos="fade-right" data-aos-duration="1500" className='lg:text-5xl md:text-3xl text-2xl lg:text-left md:text-center text-center font-semibold text-[#17A875] mb-6 md:pt-10 pt-8'>Contact me</h2>
                <div className='text-xl ml-4 lg:ml-0   text-white'>
                    <p data-aos="fade-right" data-aos-duration="1500" data-aos-delay="300" className=' mb-3 flex items-center'><img className='w-8 bg-[#17A875] rounded-full mr-3' src={call} alt='' /> <span>+880 1585-449223</span></p>
                    <p data-aos="fade-right" data-aos-duration="1500" data-aos-delay="600" className=' mb-3 flex items-center'><img className='w-8 bg-[#17A875] rounded-full mr-3' src={email} alt='' /> <span>faijul.azim.360@gmail.com</span></p>
                    <p data-aos="fade-right" data-aos-duration="1500" data-aos-delay="900" className=' mb-3 flex items-center'><img className='w-8 bg-[#17A875] rounded-full mr-3' src={address} alt='' /> <span>Boalkhali, Chittagong, Bangladesh</span></p>
                    <div className='flex mt-8'>
                        <a data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200" href='https://api.whatsapp.com/send?phone=8801585449223' target="_blank" rel='noreferrer'><img className='w-8 bg-[#17A875] rounded-full mr-8' src={whatsapp} alt='' /></a>
                        <a data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200" href='https://www.linkedin.com/in/faijul-azim' target="_blank" rel='noreferrer'><img className='w-8 bg-[#17A875] rounded-full mr-8' src={linkedIn} alt='' /></a>
                        <a data-aos="fade-up" data-aos-duration="1500" data-aos-delay="400" href='https://github.com/AzimChowdhury' target="_blank" rel='noreferrer'><img className='w-8 bg-[#17A875] rounded-full mr-8' src={github} alt='' /></a>
                        {/* <a data-aos="fade-up" data-aos-duration="1500" data-aos-delay="600" href='https://www.facebook.com/AzimChowdhury2002' target="_blank" rel='noreferrer'><img className='w-10 bg-[#17A875] rounded-full mr-6' src={facebook} alt='' /></a>
                        <a data-aos="fade-up" data-aos-duration="1500" data-aos-delay="800" href='https://www.instagram.com/f____azim' target="_blank" rel='noreferrer'><img className='w-10 bg-[#17A875] rounded-full mr-6' src={instagram} alt='' /></a>
                        <a data-aos="fade-up" data-aos-duration="1500" data-aos-delay="1000" href='https://twitter.com/AzimChy994' target="_blank" rel='noreferrer'><img className='w-10 bg-[#17A875] rounded-full mr-6' src={twitter} alt='' /></a> */}

                    </div>
                </div>
            </div>
            <div className='lg:w-7/12 flex justify-center p-4 lg:grid content-center '>
                <form ref={form} onSubmit={sendEmail}>

                    <div data-aos="fade-left" data-aos-duration="1500" className='flex mb-4'>
                        <input className='input  w-2/4 mr-2 bg-[#18191A] rounded-sm text-white' placeholder='Name' type="text" name="user_name" required />

                        <input className='input  w-2/4  bg-[#18191A] rounded-sm text-white' placeholder='Email' type="email" name="user_email" required />
                    </div>


                    <input data-aos="fade-left" data-aos-duration="1500" data-aos-delay="300" className='input mb-4 w-full bg-[#18191A] rounded-sm text-white' placeholder='Subject' type="text" name="subject" required />
                    <br />

                    <textarea data-aos="fade-left" data-aos-duration="1500" data-aos-delay="600" className=' mb-4 w-full bg-[#18191A] rounded-sm p-2 text-white' rows="5" placeholder='Message' name="message" required />

                    <br />
                    <input className='btn py-2 px-12 rounded-none text-white font-thin border-2 border-[#17A875] bg-[#17A875] hover:bg-[#17A875]' type="submit" value="Send" />
                </form>
            </div>
        </div>
    );
};